import { useCallback } from 'react'
import useForceReRender from './useForceReRender'

export default function useSetFocusById (): [ (elementId: string, reRender?: boolean) => void ] {
  const forceReRender = useForceReRender()

  const setFocusById = useCallback((elementId: string, reRender: boolean = true) => {
    const element = document.getElementById(elementId)
    element?.focus()

    if (reRender) {
      forceReRender()
    }
  }, [forceReRender])

  return [setFocusById]
}
